export default "__VITE_ASSET__CUqXQEik__"